import angular from "angular";

let mod = angular
    .module('clearClass', [])
    .directive('clearClass', function () {
        return {
            restrict: 'A',
            link: function(s, e, a) {
                let className = a['clearClass'];
                e.removeClass(className);
            }
        };
    });

export default mod.name;




// WEBPACK FOOTER //
// ./resources/assets/modules/app/clearClass.js